export default __webpack_public_path__ + "static/media/Logo-blue.41a157da.svg";